import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/02aa1c3808a6ee70ad4cf62a6af57425.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/0228ace167871453f6a1256e82da0fa1.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/382c88a35eddd9e40804da40f81da9b8.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/db7d444c48d286945715cbd21109a0f2.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/4819f9b29541e94280201cfe06ebb828.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/96b4f1d8468d578a84b533796e6e5979.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/016bd3b1d1cc00e2363fd0536ec1a997.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/35d99ffedc520186fb2d8ee8664ca0c6.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/de460f457e82a2c02e97b303ec1ad00b.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/8c46238ed668f554b005c07dd44c8916.jpeg',
    'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/8cb7ef8be6408862b90dbeace8f526fc.jpeg'
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const staffMembers = [
    {
      name: 'Sarah',
      role: 'Manager',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/ec79590621a91359d92eb07628dba5f1.png'
    },
    {
      name: 'Erika',
      role: 'Host',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/0186528d91b0847fbc3f8226f50b4792.jpeg',
      imagePosition: 'object-[center_20%]'
    },
    {
      name: 'Isha',
      role: 'Bartender',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/8be31d9d8ff77028ae4e65c0431f1378.jpeg'
    },
    {
      name: 'Mari',
      role: 'Host',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/1ca7103f7f10fc9e35e1fced860940d2.png',
      imagePosition: 'object-[center_30%]'
    },
    {
      name: 'Ana',
      role: 'Host',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/352aac9df9486523ef98465e3c9a7143.jpeg'
    },
    {
      name: 'Barbi',
      role: 'Bartender',
      image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/0df19ecaeab7fbb18b6ebe83a9b47c73.jpeg',
      imagePosition: 'object-[center_35%]'
    }
  ];

  const siteUrl = import.meta.env.VITE_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://example.com');
  const currentDate = new Date().toISOString();

  return (
    <>
      <title>フィリピンパブ　スクエア（SQuare）｜平井駅（総武線）</title>
      <meta name="description" content="平井駅徒歩3分、スクエア（SQuare）はアットホームはフィリピンクラブです。12/19リニューアルオープン。気負わずに楽しめるアットホームな空間で会話やカラオケを楽しみましょう" />
      <meta name="keywords" content="平井,フィリピン,フィリピンパブ,スクエア,SQuare,フィリピンクラブ" />
      <link rel="canonical" href={siteUrl} />
      <meta name="last-modified" content={currentDate} />
      
      <meta name="geo.position" content="35.70123;139.84567" />
      <meta name="geo.region" content="JP-13" />
      <meta name="geo.placename" content="平井" />
      
      <meta property="og:title" content="フィリピンパブ　スクエア（SQuare）｜平井駅（総武線）" />
      <meta property="og:description" content="平井駅徒歩3分、スクエア（SQuare）はアットホームはフィリピンクラブです。12/19リニューアルオープン。気負わずに楽しめるアットホームな空間で会話やカラオケを楽しみましょう" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/fd750f8b68382586473d4c4b1759ee3c.png" />
      <meta property="og:locale" content="ja_JP" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="フィリピンパブ　スクエア（SQuare）｜平井駅（総武線）" />
      <meta name="twitter:description" content="平井駅徒歩3分、スクエア（SQuare）はアットホームはフィリピンクラブです。12/19リニューアルオープン。気負わずに楽しめるアットホームな空間で会話やカラオケを楽しみましょう" />
      <meta name="twitter:image" content="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/fd750f8b68382586473d4c4b1759ee3c.png" />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NightClub",
          "name": "SQuare（スクエア）",
          "description": "平井駅徒歩3分、スクエア（SQuare）はアットホームはフィリピンクラブです。12/19リニューアルオープン。気負わずに楽しめるアットホームな空間で会話やカラオケを楽しみましょう",
          "image": "https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/fd750f8b68382586473d4c4b1759ee3c.png",
          "url": siteUrl,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "平井3-28-6 ビッグウエスト平井ビル3F-B",
            "addressLocality": "江戸川区",
            "addressRegion": "東京都",
            "postalCode": "132-0035",
            "addressCountry": "JP"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "35.70123",
            "longitude": "139.84567"
          },
          "telephone": "+81-3-1234-5678",
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            "opens": "20:00",
            "closes": "01:00"
          },
          "priceRange": "¥¥"
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "SQuareの営業時間は？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "20:00から翌1:00まで営業しております（不定休）。"
              }
            },
            {
              "@type": "Question",
              "name": "平井駅からのアクセスは？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "JR総武線「平井」駅南口から徒歩3分です。平井駅南口を出て平井駅通りを直進し、日高屋さんを右に曲がります。飲み屋さんの看板がたくさん出てるビルの3Fです。"
              }
            },
            {
              "@type": "Question",
              "name": "料金システムは？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "セット料金は1時間3,000円です。本指名2,000円、場内指名1,500円、カラオケは1曲200円または歌い放題1,000円です。サービス料10%が別途かかります（全て税別）。"
              }
            }
          ]
        })}
      </script>

      <div className="min-h-screen bg-white">
        {/* Header */}
        <header
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
            scrolled ? 'bg-[#0a1128] shadow-lg' : 'bg-[#0a1128]/20'
          }`}
        >
          <nav className="container mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <Link to="/" className="flex items-center space-x-3">
                <h1 className="flex items-center space-x-3">
                  <img
                    src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/370c06b112c63c501e86a42d993a990a.png"
                    alt="SQuare Logo"
                    className="h-12 w-auto"
                  />
                  <img
                    src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/29ed89a91001a7dfe30edfc70dbee76c.png"
                    alt="SQuare"
                    className="h-8 w-auto"
                  />
                  <span className="text-white text-sm tracking-wide">Philippine Club</span>
                </h1>
              </Link>
              <div className="hidden md:flex items-center space-x-8">
                <a href="#about" onClick={scrollToSection('about')} className="text-white hover:text-[#d4af37] transition-colors text-sm font-light whitespace-nowrap cursor-pointer">
                  About
                </a>
                <a href="#events" onClick={scrollToSection('events-section')} className="text-white hover:text-[#d4af37] transition-colors text-sm font-light whitespace-nowrap cursor-pointer">
                  イベント情報
                </a>
                <a href="#price" onClick={scrollToSection('price-section')} className="text-white hover:text-[#d4af37] transition-colors text-sm font-light whitespace-nowrap cursor-pointer">
                  システム
                </a>
                <a href="#access" onClick={scrollToSection('access-section')} className="text-white hover:text-[#d4af37] transition-colors text-sm font-light whitespace-nowrap cursor-pointer">
                  アクセス
                </a>
              </div>
            </div>
          </nav>
        </header>

        {/* Hero Section */}
        <section className="relative h-screen flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            {heroImages.map((image, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img
                  src={image}
                  alt={`SQuare Interior ${index + 1}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            ))}
            <div className="absolute inset-0 bg-gradient-to-b from-[#0a1128]/80 via-[#0a1128]/60 to-[#0a1128]/40"></div>
          </div>
          <div className="relative z-10 text-center px-6 w-full">
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/370c06b112c63c501e86a42d993a990a.png"
                alt="SQuare Mark"
                className="h-40 md:h-56 w-auto mx-auto mb-4 opacity-75"
              />
            </div>
            <img
              src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/29ed89a91001a7dfe30edfc70dbee76c.png"
              alt="SQuare"
              className="h-32 md:h-40 w-auto mx-auto mb-3 opacity-75"
            />
            <div className="mb-2">
              <span className="text-white text-2xl md:text-3xl font-bold tracking-widest font-serif">Philippine Club</span>
            </div>
            <div className="mb-6">
              <span className="text-white/90 text-lg md:text-xl tracking-wide">フィリピンクラブ　「スクエア」</span>
            </div>
            <p className="text-white text-lg md:text-xl mb-12 leading-relaxed">
              <strong>気を遣わずにくつろげる大人の社交場</strong>で<br />
              日常の疲れをいやしてください
            </p>
          </div>
          <div 
            className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer"
            onClick={() => {
              const section = document.getElementById('about');
              if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
          >
            <div className="w-8 h-8 border-2 border-[#d4af37] rounded-full flex items-center justify-center">
              <i className="ri-arrow-down-line text-[#d4af37]"></i>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-24 bg-gradient-to-br from-[#0a1128] to-[#1a1f3a]">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <p className="text-[#d4af37] text-sm tracking-widest mb-4 font-serif">/ ABOUT SQUARE</p>
              <h2 className="text-white text-5xl font-bold mb-6 leading-tight">
                <strong>気負わずに楽しめる</strong><br />アットホームな空間
              </h2>
              <p className="text-white/80 text-base leading-relaxed max-w-3xl mx-auto">
                少数の客席と明るい女の子のいるアットホームな空間です。カジュアルな店内で<strong>会話やカラオケ</strong>などを楽しみ、日常の疲れをいやしてください。
お酒も多数ご用意しています。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 max-w-6xl mx-auto">
              {[
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/db7d444c48d286945715cbd21109a0f2.jpeg',
                  alt: '店内の雰囲気1'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/4819f9b29541e94280201cfe06ebb828.jpeg',
                  alt: '店内の雰囲気2'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/382c88a35eddd9e40804da40f81da9b8.jpeg',
                  alt: '店内の雰囲気3'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/96b4f1d8468d578a84b533796e6e5979.jpeg',
                  alt: 'カラオケスペース'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/4e500657e3a7189c2d1aef553781867c.jpeg',
                  alt: 'ドリンク'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/f2f55d6b515366c67a421db5261d7624.jpeg',
                  alt: '店内の雰囲気4'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/016bd3b1d1cc00e2363fd0536ec1a997.jpeg',
                  alt: 'プライベートブース'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/35d99ffedc520186fb2d8ee8664ca0c6.jpeg',
                  alt: 'エントランス'
                },
                {
                  image: 'https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/7cd2e320b0b63aa665fdc791c121098e.jpeg',
                  alt: '店内の雰囲気5'
                }
              ].map((item, index) => (
                <div key={index} className="group cursor-pointer">
                  <div className="relative overflow-hidden rounded-2xl shadow-xl h-[280px] w-full">
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1128]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Events Preview */}
        <section id="events-section" className="py-24 bg-[#f5f1e8]">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-[#0a1128] text-6xl font-serif font-bold mb-4">Event Information</h2>
              <p className="text-gray-600 text-sm">今後のイベント</p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {[
                {
                  date: 'NEW',
                  title: '昼カラ、始めました！歌い放題２００円！',
                  description: 'お昼の時間帯にカラオケを楽しめる「昼カラ」をスタート！明るい時間帯にリラックスしながら、好きなだけ歌ってください。歌い放題・飲み放題2000円です。',
                  image: 'https://public.readdy.ai/ai/img_res/8a7b4ece9604000b51a4a2acb1a0755e.jpg',
                  badge: 'gold'
                },
                {
                  date: '12/24-25',
                  title: 'クリスマススペシャルナイト',
                  description: '特別なクリスマスイブをSQuareで。プレミアムシャンパンとスペシャルメニューで、忘れられない夜をお届けします。',
                  image: 'https://readdy.ai/api/search-image?query=Christmas%20special%20night%20at%20luxury%20club%2C%20elegant%20holiday%20decorations%20with%20navy%20blue%20and%20gold%20theme%2C%20champagne%20glasses%2C%20festive%20sophisticated%20atmosphere%2C%20upscale%20nightclub%20Christmas%20celebration%2C%20professional%20photography&width=600&height=400&seq=event2&orientation=landscape'
                },
                {
                  date: '12/19',
                  title: 'グランドリニューアルオープン',
                  description: '新装開店を記念して、特別なイベントを開催いたします。豪華なドリンクサービスをお楽しみください。',
                  image: 'https://readdy.ai/api/search-image?query=Elegant%20champagne%20bottles%20lined%20up%20in%20a%20row%20at%20upscale%20nightclub%20bar%2C%20professional%20product%20photography%20with%20beautiful%20bokeh%20blurred%20background%2C%20soft%20ambient%20lighting%20with%20navy%20blue%20and%20gold%20tones%2C%20luxury%20celebration%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20sophisticated%20composition&width=600&height=400&seq=event1champagne&orientation=landscape'
                }
              ].map((event, index) => (
                <article key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#d4af37]/20 hover:shadow-2xl transition-shadow">
                  <div className="relative h-64 w-full">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className={`absolute top-4 left-4 px-4 py-2 rounded-full text-sm font-medium ${event.badge === 'gold' ? 'bg-[#d4af37] text-[#0a1128] animate-pulse' : 'bg-[#d4af37] text-[#0a1128]'}`}>
                      {event.date}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-[#0a1128] text-xl font-bold mb-3 font-serif">{event.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{event.description}</p>
                  </div>
                </article>
              ))}
            </div>
            <div className="flex justify-center items-center space-x-4">
              <button className="w-12 h-12 border border-gray-300 rounded-full flex items-center justify-center hover:border-[#d4af37] transition-colors cursor-pointer" aria-label="Previous">
                <i className="ri-arrow-left-line text-gray-400"></i>
              </button>
              <button className="w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#f0d98d] transition-colors cursor-pointer" aria-label="Next">
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </div>
        </section>

        {/* Price List Preview */}
        <section id="price-section" className="py-24 bg-gradient-to-br from-[#0a1128] via-[#1a1f3a] to-[#2a1f1a]">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <p className="text-[#d4af37] text-sm tracking-widest mb-4 font-serif">/ PRICE LIST</p>
              <h2 className="text-white text-5xl font-bold mb-4">システム</h2>
              <p className="text-white/80 text-base">料金システムのご案内</p>
            </div>
            
            <div className="max-w-3xl mx-auto">
              <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
                <div className="space-y-8">
                  <div className="flex justify-between items-center pb-6 border-b-2 border-[#d4af37]">
                    <h3 className="text-[#0a1128] text-2xl font-bold">セット料金</h3>
                    <div className="text-right">
                      <span className="text-[#d4af37] text-4xl font-bold">¥3,000</span>
                      <span className="text-gray-600 text-lg ml-2">/ 1時間</span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center pb-6 border-b border-gray-200">
                    <h4 className="text-[#0a1128] text-xl font-bold">本指名</h4>
                    <div className="text-right">
                      <span className="text-[#d4af37] text-3xl font-bold">¥2,000</span>
                      <span className="text-gray-600 text-base ml-2">/ 1時間</span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center pb-6 border-b border-gray-200">
                    <h4 className="text-[#0a1128] text-xl font-bold">場内指名</h4>
                    <div className="text-right">
                      <span className="text-[#d4af37] text-3xl font-bold">¥1,500</span>
                      <span className="text-gray-600 text-base ml-2">/ 1時間</span>
                    </div>
                  </div>

                  <div className="pb-6 border-b border-gray-200">
                    <h4 className="text-[#0a1128] text-xl font-bold mb-4">カラオケ</h4>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">1曲</span>
                        <span className="text-[#d4af37] text-2xl font-bold">¥200</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">歌い放題</span>
                        <span className="text-[#d4af37] text-2xl font-bold">¥1,000</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    <h4 className="text-[#0a1128] text-xl font-bold">サービス料</h4>
                    <span className="text-[#d4af37] text-3xl font-bold">10%</span>
                  </div>
                </div>

                <div className="mt-10 pt-8 border-t-2 border-gray-200">
                  <p className="text-gray-500 text-sm text-center">※表示価格は全て税別です</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Staff Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <p className="text-[#d4af37] text-sm tracking-widest mb-4 font-serif">/ OUR STAFF</p>
              <h2 className="text-[#0a1128] text-5xl font-serif font-bold mb-6">スタッフ紹介</h2>
              <p className="text-gray-600 text-base max-w-2xl mx-auto">
                明るいスタッフが皆さまに最高のおもてなしを提供します
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {staffMembers.map((staff, index) => (
                <div key={index} className="group cursor-pointer">
                  <div className="relative overflow-hidden rounded-2xl mb-4 w-full h-[300px]">
                    <img
                      src={staff.image}
                      alt={staff.name}
                      className={`w-full h-full object-cover ${staff.imagePosition || 'object-top'} transition-transform duration-500 group-hover:scale-110`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1128]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="text-center">
                    <h3 className="text-[#0a1128] font-bold text-lg mb-1 font-serif">{staff.name}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Access Preview */}
        <section id="access-section" className="py-24 bg-[#f5f1e8]">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="rounded-2xl overflow-hidden shadow-xl h-[500px] w-full">
                <iframe
                  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=東京都江戸川区平井3-28-6&zoom=16&language=ja"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="SQuare Location"
                ></iframe>
              </div>
              <div>
                <h2 className="text-[#0a1128] text-5xl font-serif font-bold mb-8">Access Information</h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-map-pin-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-[#0a1128] font-bold mb-1">住所</h4>
                      <p className="text-gray-600 text-sm"><strong>東京都江戸川区平井3-28-6</strong>　ビッグウエスト平井ビル3F-B</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-time-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-[#0a1128] font-bold mb-1">営業時間</h4>
                      <p className="text-gray-600 text-sm">20:00 - 翌1:00(不定休)</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-train-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-[#0a1128] font-bold mb-1">最寄り駅</h4>
                      <p className="text-gray-600 text-sm"><strong>JR総武線「平井」駅徒歩3分</strong></p>
                    </div>
                  </div>
                </div>

                {/* 道順案内 */}
                <div className="mt-8 bg-white rounded-2xl p-6 shadow-lg">
                  <h4 className="text-[#0a1128] font-bold text-lg mb-4 flex items-center">
                    <i className="ri-route-line text-[#d4af37] mr-2"></i>
                    道順のご案内
                  </h4>
                  <div className="space-y-3">
                    {[
                      { step: '1', text: '平井駅南口を出て平井駅通りを直進' },
                      { step: '2', text: '日高屋さんを右に曲がります' },
                      { step: '3', text: '飲み屋さんの看板がたくさん出てるビルの3Fです' }
                    ].map((item, index) => (
                      <div key={index} className="flex items-start">
                        <div className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                          <span className="text-white text-sm font-bold">{item.step}</span>
                        </div>
                        <p className="text-gray-600 text-sm pt-1">{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 建物の画像 */}
                <div className="mt-8 grid grid-cols-2 gap-4">
                  <div className="rounded-xl overflow-hidden shadow-lg h-[200px] w-full">
                    <img
                      src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/88b43d1d5133fe51883f6c36822f940f.png"
                      alt="ビル外観1"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden shadow-lg h-[200px] w-full">
                    <img
                      src="https://static.readdy.ai/image/a82686c8940d00d69661acca2b5bbb86/325d74517b21ee84bd7131d2ddea93d7.png"
                      alt="ビル外観2"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <a
                  href="https://www.google.com/maps/search/?api=1&query=東京都江戸川区平井3-28-6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-[#d4af37] text-[#0a1128] px-8 py-4 rounded-full mt-8 hover:bg-[#f0d98d] transition-all cursor-pointer whitespace-nowrap"
                >
                  Googleマップで開く
                  <i className="ri-external-link-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-[#050814] py-8">
          <div className="container mx-auto px-6">
            <div className="text-center">
              <p className="text-gray-500 text-xs">© 2025 SQuare. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
